<template>
  <div class="main" v-if="$store.state.menuList.length!==0&&$store.state.userInfo.user">
    <div class="main-logo">
      <img class="login-title-logo"
           src="@/assets/logo.png" />
      <span>凤凰市场网络管理</span>
    </div>
    <div class="main-header">
      <div class="main-title">{{title}}</div>
      <div class="main-user_info">
        <div class="main-message_button">
            <el-button class="main-message_icon"
                       type="info"
                       circle
                       @click="gotoMessge()">
              <font-awesome-icon class='user-upload_icon'
                                 :icon="['fas', 'envelope']" />

            </el-button>
        </div>
        <img  :src="$store.state.userInfo.user.networkHeadUrl">
        <el-dropdown @command="handleCommand" trigger="click">
          <span class="el-dropdown-link">
            {{$store.state.userInfo.user.name}}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="toUserCenter">个人中心</el-dropdown-item>
            <el-dropdown-item  command="logout">注销</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="main-page">
      <router-view></router-view>
    </div>
    <el-menu :default-active="id.toString()"
             class="main-menu"
             background-color="#292E2F"
             text-color="#fff"
             active-text-color="#fff">
      <el-menu-item index="-1"
                    disabled>
        <span slot="title">Main</span>
      </el-menu-item>
      <el-menu-item @click="changePage(item)"
                    v-for='item in mainList'
                    :index="(item.id).toString()"
                    :key='item.id'>
        <div v-if="item.id!==59" class="icon">
          <font-awesome-icon :icon="item.icon" />
        </div>
        <div v-else class="icon">
           <img src="@/assets/white_logo.png"/>
        </div>
        <span slot="title">{{item.name}}</span>
      </el-menu-item>
      <el-menu-item index="-2"
                    disabled>
        <span slot="title">Setting</span>
      </el-menu-item>
      <el-menu-item @click="changePage(item)"
                    v-for='item in settingList'
                    :index="(item.id).toString()"
                    :key='item.id'>
        <div class="icon">
          <font-awesome-icon :icon="item.icon" />
        </div>
        <span slot="title">{{item.name}}</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>


<script>
import axios from '@/servies/axios'
import api from '@/servies/api'
export default {
  data() {
    return {
      id:2,
      mainList: [],
      settingList: [],
      menuList: [],
      title: '',
      hasFenghuang:false,
    }
  },
  async created() {
    if(this.$route.path.indexOf('public')!==-1){
      this.title = "行政中心"
      this.id = 2
    } else if(this.$route.path.indexOf('information')!==-1){
      this.title = "资讯中心"
      this.id = 3
    }else if(this.$route.path.indexOf('apply')!==-1){
      this.title = "业务申请"
      this.id = 4
    }else if(this.$route.path.indexOf('message')!==-1){
      this.title = "消息中心"
      this.id = 5
    }else if(this.$route.path.indexOf('fenghuang')!==-1){
      this.title = "凤凰专区"
      this.id = 59
    }else if(this.$route.path.indexOf('usercenter')!==-1){
      this.title = "个人中心"
      this.id = 10
    }else if(this.$route.path.indexOf('usermanagement')!==-1){
      this.title = "系统管理"
      this.id = 11
    }else if(this.$route.path.indexOf('data')!==-1){
      this.title = "数据统计"
      this.id = 50
    } else if (this.$route.path.indexOf('data')!==-1){
      this.title = "消息中心"
      this.id = 5
    } else if (this.$route.path.indexOf('data')!==-1){
      this.title = "资讯中心"
      this.id = 3
    } else if (this.$route.path.indexOf('ch_channel')!==-1){
      this.title = "中文台资讯台"
      this.id = 7
    } else if (this.$route.path.indexOf('mv_channel')!==-1){
      this.title = "电影台"
      this.id = 8
    }
    await this.$store.dispatch('getMenu')
  await this.$store.dispatch('getUser')
    this.mainList = this.$store.state.mainList
    this.settingList = this.$store.state.settingList
  },
  methods: {
    // 跳转页面
    changePage(item) {
      this.title = item.name
      this.$router.push({
        path: item.path
      })
    },
    handleCommand(command){
      if(command==="logout"){
        this.logout()
      } else{
        this.toUserCenter()
      }
    },
    //注销
    logout(){
      axios.get(api.logout).then(res => {
        if(res.data.code === 0) {
          console.log("注销成功")
          this.$router.replace({path:'/login'})
        } else {
          console.log('注销失败', res.data.msg)
          this.$message.error('网络错误，请稍后重试');
        }
      }).catch(error => {
        console.log('注销失败',error)
        this.$message.error('网络错误，请稍后重试');
      })

    },
    // 跳转到个人中心
    toUserCenter() {
      this.title = "个人中心"
      this.id = 10
      this.$router.push({path:'/usercenter'})
    },
    gotoMessge(){
      this.title = "消息中心"
      this.id = 5
      this.$router.push({name:'message'})
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  height: 100%;
  .main-logo {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    height: 64px;
    align-items: center;
    padding-left:8px;
    text-align: center;
    background: #212425;
    color: #fff;
    width: 180px;
    font-size: 17px;
    border-bottom: 2px solid rgba(26, 29, 30, 1);
    img{
      margin-right: 4px;
      width: 22px;
      height: 22px;
    }
  }
  .main-header {
    display: flex;
    position: fixed;
    align-items: center;
    justify-content: space-between;
    width: calc(100% - 180px);
    left: 180px;
    top: 0px;
    z-index: 1000;
    background: #fff;
    padding-right: 20px;
    box-sizing: border-box;
    .main-title {
      line-height: 64px;
      height: 64px;
      padding-left: 30px;
      color: #303133;
      font-size: 18px;
      font-weight: 600;
    }
    .main-user_info {
      display: flex;
      align-items: center;
      .main-message_button {
        margin-right: 15px;
        .main-message_icon {
          height: 32px;
          width: 32px;
          border: 0;
          background: #efefef;
          padding: 0px;
          line-height: 32px;
          text-align: center;

          .user-upload_icon {
            color: #4a4a4a;
          }
        }
      }
      img {
        height: 32px;
        width: 32px;
        border-radius: 50%;
        background: #eee;
        margin-right: 15px;
      }
    }
  }
  .main-page {
    position: absolute;
    top: 64px;
    left: 180px;
    width: calc(100% - 180px);
  }
  .main-menu {
    position: fixed;
    top: 65px;
    left: 0;
    width: 180px;
    height: calc(100% - 64px);
    .icon {
      padding-right: 5px;
      width: 16px;
      display: inline-block;
      img{
        height: 16px;
        width: 16px;
        position: relative;
        top:-3px;
      }
    }
  }
}
</style>
